import {ItemQuantityInfo} from '@wix/auto_sdk_ecom_current-cart-v-2';

export class QuantityInfoModel {
  public quantity: number;
  public availableQuantity: number;
  public fixedQuantity: boolean;

  constructor(params: QuantityInfoModel) {
    this.quantity = params.quantity;
    this.availableQuantity = params.availableQuantity;
    this.fixedQuantity = params.fixedQuantity;
  }

  public static fromCartV1({
    quantity,
    availableQuantity,
    fixedQuantity,
  }: {
    quantity: number;
    availableQuantity?: number;
    fixedQuantity: boolean;
  }) {
    return new QuantityInfoModel({
      quantity,
      availableQuantity,
      fixedQuantity,
    });
  }

  public static fromCartV2(quantityInfo: ItemQuantityInfo): QuantityInfoModel {
    return new QuantityInfoModel({
      quantity: quantityInfo.confirmedQuantity,
      availableQuantity: quantityInfo.availableQuantity,
      fixedQuantity: quantityInfo.fixedQuantity ?? /* istanbul ignore next */ false,
    });
  }
}
